export const checkRequiredField = (input) => { // eslint-disable-line arrow-body-style
    return (!input || input.replace(/\s/g, '') === '') ? 'Required' : undefined; // key for localization lookup
};

export const validateEmail = (input) => {
    const email = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/igm;
    let retVal = checkRequiredField(input);

    if (!retVal && input && !input.match(email)) {
        retVal = 'InvalidEmailAddress'; // key for localization lookup
    }
    return retVal;
};

/**
 * @description Field formats supported
 * (999)-999-9999
 * 999-999-9999
 * 1 (999)-999-9999
 * 1-999-999-9999
 * +1-999-999-9999
 * 1-999-999-9999 ext.123
 */
export const validatePhone = (input) => {
    // eslint-disable-next-line max-len
    const regex = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/g;

    let retVal = checkRequiredField(input);
    if (!retVal && !regex.test(input)) {
        retVal = 'InvalidPhoneNumber'; // key for localization lookup
    }

    return retVal;
};



// WEBPACK FOOTER //
// ./src/services/validation/index.js